import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const SessionSelection = ({ onSessionChange, disabled, sx }) => {
  const [selectedSession, setSelectedSession] = useState("");
  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedSession(value);
    onSessionChange(value);
  };

  const sxArray = Array.isArray(sx) ? sx : sx ? [sx] : [];
  const baseSx = {
    backgroundColor: "rgba(245, 255, 245, 0.06)",
    borderRadius: "18px",
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(245, 255, 245, 0.1)",
    },
    "& .MuiOutlinedInput-root": {
      color: "#F5FFF5",
      "& fieldset": {
        borderColor: "rgba(245, 255, 245, 0.35)",
      },
      "&:hover fieldset": {
        borderColor: "#B8FFDA",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#B8FFDA",
        boxShadow: "0 0 0 2px rgba(184, 255, 218, 0.25)",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "rgba(245, 255, 245, 0.2)",
      },
    },
    "& .MuiSelect-select": {
      color: "#F5FFF5",
      paddingTop: "14px",
      paddingBottom: "14px",
      fontWeight: 500,
    },
    "& .MuiSvgIcon-root": {
      color: "#B8FFDA",
    },
    "& .MuiInputLabel-root": {
      color: "rgba(245, 255, 245, 0.85)",
      fontWeight: 600,
      letterSpacing: "0.02em",
      "&.Mui-focused": {
        color: "#B8FFDA",
      },
      "&.Mui-disabled": {
        color: "rgba(245, 255, 245, 0.55)",
      },
    },
    "& .MuiFormHelperText-root": {
      color: "rgba(245, 255, 245, 0.75)",
      marginLeft: 0,
      marginRight: 0,
    },
  };
  const combinedSx = [baseSx, ...sxArray];

  return (
    <FormControl
      fullWidth
      variant="outlined"
      disabled={disabled}
      sx={combinedSx}
    >
      <InputLabel id="sessionType" shrink>
        Session Type
      </InputLabel>
      <Select
        labelId="sessionType"
        label="Session Type"
        value={selectedSession}
        onChange={handleChange}
        displayEmpty
        renderValue={(value) =>
          value ? (
            value
          ) : (
            <span className="booking-select-placeholder">Select a session</span>
          )
        }
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "rgba(10, 36, 18, 0.96)",
              color: "#F5FFF5",
              "& .MuiMenuItem-root.Mui-selected": {
                backgroundColor: "rgba(142, 255, 185, 0.18)",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "rgba(142, 255, 185, 0.12)",
              },
            },
          },
        }}
      >
        <MenuItem disabled value="">
          <span className="booking-select-placeholder">Select a session</span>
        </MenuItem>
        <MenuItem value="morning">Morning</MenuItem>
        <MenuItem value="afternoon">Afternoon</MenuItem>
        <MenuItem value="full day">Full Day</MenuItem>
      </Select>
      <FormHelperText>
        Morning departures leave at 06:30, afternoon at 14:30, and full day
        tours span both sessions.
      </FormHelperText>
    </FormControl>
  );
};

export default SessionSelection;
